module.exports = __webpack_public_path__ + "img/bulgaria.264df709.png";